import request from '@/utils/request'

export function getMessageConfig() {
  return request({ url: '/admin/message/config', method: 'post', data: {} })
}

export function getMessageList(data) {
  return request({ url: '/admin/message/list', method: 'post', data })
}

export function sendMessage(data) {
  return request({ url: '/admin/message/send', method: 'post', data })
}

export function deleteMessage(data) {
  return request({ url: '/admin/message/delete', method: 'post', data })
}
